import $ from 'jquery';
import sidebarWithContentWidget from '../../Widgets/Layout/contentWithSidebar';

const init = function sidebarWithContent() {
  var $contentSidebar = $('.js-contentWithSidebar');

  if ($contentSidebar.length > 0) {
    sidebarWithContentWidget.create($contentSidebar);
  }
};

export default {
  init,
};
